import Feature from 'ol/Feature'
import GeoJSON from 'ol/format/GeoJSON'
import Geolocation from 'ol/Geolocation'
import Point from 'ol/geom/Point'
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import Fill from 'ol/style/Fill'
import Icon from 'ol/style/Icon'
import Stroke from 'ol/style/Stroke'
import Style from 'ol/style/Style'
import Text from 'ol/style/Text'

import { flyToExtent, getLayerIndex, map, removeLayerById } from './map/tools'
import { materializeToast, showMessageBox } from './notifications'
import { minDrawingZoom } from './storage'

import markerUrl from '/img/marker.png';

let nordCoord = 0;
let ostCoord = 0;
let utmSone = 35;

function iconStyleFunc(feature, resolution) {
  let label = 'Nord: ' + nordCoord + '\nØst: ' + ostCoord + '\nUTM: ' + utmSone;
  const geoType = feature.getGeometry().getType();
  if (geoType === 'Polygon') {
    label = 'Gårds-/bruksnr: \n' + searchInput.value;
  }
  const iconStyle = new Style({
    stroke: new Stroke({ color: '#FF9999', width: 3 }),
    image: new Icon({
      anchor: [0.5, 46],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      opacity: 0.75,
      // src: '../img/marker.png' // does not work on server
      src: markerUrl
    }),
    text: new Text({
      font: '14px arial,sans-serif',
      text: label,
      fill: new Fill({ color: 'Black' }),
      textAlign: 'center',
      textBaseline: 'bottom',
      offsetY: 15,
      offsetX: 70,
      backgroundFill: new Fill({ color: 'white' }),
      padding: [3, 5, 3, 5]
    })
  });
  return [iconStyle];
}

const goToBoundary = searchText => {
  showMessageBox('gnrSearchMessage');
  const hnrText = searchText.replace(/ /g, '');
  // Remove old boundary, if any:
  removeLayerById('boundary');
  // const currentProj = map.getView().getProjection().getCode().split(':')[1];
  // [ 3014-245/2 (32)  3014-245/2 (33)  5444-20/2 (35) ]
  const hnr = hnrText.split(/[-/]+/);
  // Kan inneholde mellomrom, tall, - og / med lengde 8-12
  const validGNRString = /^[0-9-/]{8,12}$/.test(hnrText);
  if (validGNRString && (hnr.length > 2) && hnr[2]) {
    loadingSearch.classList.add('active');
    const property = hnr[0] + ',' + hnr[1] + ',' + hnr[2] + ',' + (hnr[3] || 0);
    getPropertyBorder(property);
  } else{
    searchInput.setCustomValidity('Vennligst legg inn eiendom med Kommunenummer-Gnr/Bnr');
  }
};

let boundaryRequest;
function getPropertyBorder(property) {
  if (boundaryRequest) { boundaryRequest.abort(); } // avoid hanging requests
  const p = map.getView().getProjection().getCode();
  const maturl = '/matrikkel/' + property + ',' + p.split(':')[1];
  boundaryRequest = $.getJSON(maturl, propertyJson => {
    if (propertyJson.features && propertyJson.features.length > 0) {
      const data = new GeoJSON().readFeatures(propertyJson);
      const boundaryLayer = addBoundary(data);
      // map.getView().fit(boundaryLayer.getSource().getExtent());
      flyToExtent(boundaryLayer.getSource().getExtent());
    } else {
      materializeToast('Fant ikke denne eiendommen', 'error');
    }
    loadingSearch.classList.remove('active');
  }).fail(() => {
    materializeToast('Får ikke tak i eiendomsgrenser fra matrikkelen', 'error');
    loadingSearch.classList.remove('active');
  });
}

function addBoundary(boundary) {
  const source = new VectorSource({ features: boundary });
  const layer = new VectorLayer({
    id: 'boundary', source: source, style: iconStyleFunc, zIndex: 2
  });
  // map.addLayer(layer);
  // Insert layer before drawings:
  map.getLayers().insertAt(getLayerIndex('vectorLayer') + 1, layer);
  return layer;
}

function addMarker(point) {
  const iconFeature = new Feature({ geometry: point });
  iconFeature.setStyle(iconStyleFunc);
  const source = new VectorSource({ features: [iconFeature] });
  const layer = new VectorLayer({ id: 'marker', source: source, zIndex: 2 });
  // map.addLayer(layer);
  // Insert layer before drawings:
  map.getLayers().insertAt(getLayerIndex('vectorLayer') + 1, layer);
}

export const updateVectorLayersProjection = (oldEpsg, newEpsg) => {
  // console.log('Update marker position from', oldEpsg, 'to', newEpsg);
  map.getLayers().forEach((layer, i) => {
    // console.log(i, layer.get('id'), (layer instanceof VectorLayer));
    // if (['boundary', 'marker'].indexOf(layer.get('id')) > -1) {
    if (layer instanceof VectorLayer) {
      layer.getSource().getFeatures().forEach((f, i) => {
        f.getGeometry().transform(oldEpsg, newEpsg);
        nordCoord = Math.round(f.getGeometry().getCoordinates()[1]);
        ostCoord = Math.round(f.getGeometry().getCoordinates()[0]);
        utmSone = newEpsg.slice(-2);
      });
    }
  });
};

const goToCoordinate = (north, east, utm) => {
  if (!north) north = Number(coordNord.value);
  if (!east) east = Number(coordOst.value);
  if (!utm) utm = coordUTM.value;
  removeLayerById('marker'); // remove old marker, if any.
  const currentProj = map.getView().getProjection().getCode().split(':')[1];
  utm = utm ?? Number(currentProj.slice(-2)); // in case of emtpy field.
  nordCoord = north; // used for marker label
  ostCoord = east; // used for marker label
  utmSone = utm; // used for marker label
  let suggestedProjection = currentProj;
  if (utm) {
    if ([32, 33, 35].indexOf(utm) > -1) suggestedProjection = '258' + utm;
  }
  const e = 'EPSG:';
  const coord = [east, north];
  const point = new Point(coord);
  // Transform input coordinates from suggested to current projection:
  addMarker(point.transform(e + suggestedProjection, e + currentProj));
  const view = map.getView();
  const z = Math.max(view.getZoom(), minDrawingZoom, 10); // closest
  setTimeout(() => { // needed to see the marker during animation
    view.animate({ center: point.getCoordinates(), zoom: z, duration: 1800 });
  }, 100);
  setTimeout(() => showMessageBox('coordSearchMessage'), 500);
};

searchInput.onchange = () => searchInput.setCustomValidity('');
searchInput.onkeyup = (e) => showResult(e.target.value);

coordForm.oninput = () => {
  // console.log('oninput', coordForm.checkValidity());
  const btn = document.getElementById('goToCoordinateBtn');
  if (coordForm.checkValidity()) btn.classList.add('validForm');
  else btn.classList.remove('validForm');
};
coordForm.oninput(); // In case of page refresh with filled in fields

const clearCoordinates = () => {
  coordNord.focus();
  removeLayerById('marker');
  // Set right button colour:
  // coordForm.oninput(); // does no work because validity is false as last step
  goToCoordinateBtn.classList.remove('validForm');
};

const showResult = (stringWithWhiteSpacesOnBothSides) => {
  if (event.key === 'Enter') return; // no need to request lists.
  const str = stringWithWhiteSpacesOnBothSides.trim();
  if (str.length === 0) {
    cleanSearchResultAll();
    return;
  }
  const xmlhttpStedsnavn = new XMLHttpRequest();
  const xmlhttpMatrikkel = new XMLHttpRequest();
  xmlhttpStedsnavn.onreadystatechange = () => {
    if (xmlhttpStedsnavn.readyState === 4 && xmlhttpStedsnavn.status === 200) {
      cleanSearchResult();
      const response = JSON.parse(xmlhttpStedsnavn.responseText);
      const numberOfMatches = response.metadata.totaltAntallTreff;
      const matches = response.navn;
      if (numberOfMatches > 0) {
        const container = document.getElementById('result');
        const header = document.createElement('div');
        header.id = 'resultheader';
        header.innerHTML = 'Stedsnavnstreff';
        container.parentNode.insertBefore(header, container);
        matches.forEach(m => {
          const type = m.navneobjekttype;
          if (['Kommune', 'Fylke'].indexOf(type) < 0 && m.kommuner) {
            const municipality = m.kommuner[0].kommunenavn;
            const li = document.createElement('li');
            li.id = m.stedsnummer;
            li.innerHTML = m.skrivemåte + ', ' + type + ', ' + municipality;
            li.data = m.representasjonspunkt;
            li.onclick = () => getSelectedValue(li);
            container.appendChild(li);
          }
        });
        result.style.border = '1px solid #A5ACB2';
      }
    }
  };
  xmlhttpMatrikkel.onreadystatechange = () => {
    if (xmlhttpMatrikkel.readyState === 4 && xmlhttpMatrikkel.status === 200) {
      cleanSearchResultMatrikkel();
      const response = JSON.parse(xmlhttpMatrikkel.responseText);
      if (response.length > 0) {
        const container = document.getElementById('resultMatrikkel');
        response.forEach(match => {
          if (match.attrs.objektType === 'EIENDOM') {
            const isFarm = match.attrs.landbrukseiendom || false;
            const li = document.createElement('li');
            li.id = match.id;
            li.class = isFarm ? 'landbrukseiendom' : '';
            li.innerHTML = capitalizeFirstLetter(match.attrs.title);
            li.onclick = () => getSelectedValueMatrikkel(li);
            container.appendChild(li);
          }
        });
        if (container.children.length > 0) {
          const header = document.createElement('div');
          header.id = 'resultheaderMatrikkel';
          header.innerHTML = 'Matrikkeltreff';
          container.parentNode.insertBefore(header, container);
          resultMatrikkel.style.border = '1px solid #A5ACB2';
        }
      }
    }
  };
  const limit = 'treffPerSide=20';
  const p = map.getView().getProjection().getCode();
  const utm = 'utkoordsys=' + p.split(':')[1];
  const side = 'side=1';
  const fuzzy = 'fuzzy=true';
  const pattern = 'sok=' + str + '*';
  const stedsnavnUrl = 'https://ws.geonorge.no/stedsnavn/v1/navn';
  const places = `${stedsnavnUrl}?${fuzzy}&${side}&${limit}&${utm}&${pattern}`;
  xmlhttpStedsnavn.open('GET', places);
  // New service will replace kilden_ws:
  const matrikkelUrl = 'kilden.nibio.no/kilden_ws/rest/services/search';
  const cadastre = `https://${matrikkelUrl}?src=utm33&search=${str}`;
  xmlhttpMatrikkel.open('GET', cadastre);

  xmlhttpStedsnavn.send();
  xmlhttpMatrikkel.send();
};

//trigger from li element, seak in a array or its only a object
const getSelectedValue = (li) => {
  searchInput.value = li.innerHTML;
  cleanSearchResultAll();
  const coord = li.data;
  const north = Math.round(coord.nord);
  const east = Math.round(coord.øst);
  const c = map.getView().getProjection().getCode().split(':')[1].slice(-2);
  // const utm = coord.koordsys ? coord.koordsys.slice(-2) : c; // string
  const utm = coord.koordsys ? coord.koordsys % 100 : c; // integer
  goToCoordinate(north, east, utm);
};

//trigger from li element
const getSelectedValueMatrikkel = (li) => {
  const title = li.innerHTML;
  const validGNRString = /^[0-9-/]{8,14}$/.test(title);
  const gnr = validGNRString ? title : title.split('(')[1].split(')')[0];
  searchInput.value = gnr;
  cleanSearchResultAll();
  goToBoundary(gnr.replace(/ /g, ''));
};

// trigger from x button
const clearSearchField = () => {
  searchInput.focus();
  searchInput.value = '';
  cleanSearchResultAll();
  removeLayerById('boundary');
  removeLayerById('marker');
};

//clean all result
function cleanSearchResultAll() {
  cleanSearchResult();
  cleanSearchResultMatrikkel();
}

function cleanSearchResult() {
  $('#result').empty();
  $('#resultheader').remove();
  result.style.border = '0px';
}

function cleanSearchResultMatrikkel() {
  $('#resultMatrikkel').empty();
  $('#resultheaderMatrikkel').remove();
  resultMatrikkel.style.border = '0px';
}

//change to big first letter in resultMatrikkel
function capitalizeFirstLetter(string) {
  const text = string.toLowerCase();
  return text.replace(/(^\w{1})|(\s{1}\w{1})/g, match => match.toUpperCase());
}

const goToFirstMatch = () => {
  const sted = document.getElementById('result');
  if (sted.childNodes.length > 0) getSelectedValue(sted.firstChild)
  else { // Matrikkel
    const m = document.getElementById('resultMatrikkel');
    if (m.childNodes.length > 0) getSelectedValueMatrikkel(m.firstChild)
  }
};

const geolocation = new Geolocation();
geolocation.on('change:position', () => {
  const [ee, nn] = geolocation.getPosition();
  const e = Math.round(ee);
  const n = Math.round(nn);
  const p = Number(geolocation.getProjection().getCode().slice(-2));
  geolocation.setTracking(false);
  coordNord.value = n;
  coordOst.value = e;
  coordUTM.value = p;
  Materialize.updateTextFields(); // prevents writing over labels.
  goToCoordinate(n, e, p);
});
geolocation.on('error', () => {
  materializeToast('Din posisjon er dessverre ikke tilgjengelig', 'error')
  geolocation.setTracking(false);
});
const goToLocation = () => {
  geolocation.setProjection(map.getView().getProjection());
  geolocation.setTracking(true);
  // console.log(geolocation.getPosition()); // still undefined
};

searchForm.onsubmit = () => { goToFirstMatch(); return false; };
coordForm.onsubmit = () => goToCoordinate(0, 0, 0);
geolocate.onclick = goToLocation;
resetSearch.onclick = clearSearchField;
resetCoords.onclick = clearCoordinates;
